import React, { useMemo } from 'react';
import { Timestamp, toMomentFromAny } from '../../services/time';

export const Date = ({
  d,
  format
}: {
  d: string | number | null | undefined | Timestamp;
  format?: string;
}) => {
  const m = useMemo(() => (d ? toMomentFromAny(d) : null), [d]);
  if (!m) {
    return <span />;
  }
  return <span>{m.format(format || 'L')}</span>;
};
